module.exports = __webpack_public_path__ + "img/beauty-pass.95c45b6.svg";